<template>
  <div>
    <Fieldset :legend="translate('experience', 'ucfirst')"
      class="w-full px-5 py-2 mt-5 bg-white rounded-lg shadow-md border border-color-iron">
      <Skeleton v-if="isLoading && listExperiences" height="1.5rem" class="mb-2"></Skeleton>
      <span v-else-if="!isLoading && listExperiences.length > 0" class="w-full">
        <article v-for="(experience, index) in listExperiences" :key="index" class="mb-6">
          <div class="mb-2">
            <h1 class="uppercase font-bold text-oxford-blue">{{ experience.job_title }}</h1>
            <h3 class="text-sm font-semibold text-oxford-blue">{{ experience.company_name }}</h3>
            <span class="font-semibold">
              <small>{{ dateFormated(experience.start_date) }}</small> - <small>
              {{ 
                experience.end_date == new Date() 
                ? translate('until now', 'ucfirst')
                : dateFormated(experience.end_date) 
              }}
              </small>
            </span>
          </div>
          <p class="mr-2 pr-3 w-4/5 text-wrap">{{ experience.description }}</p>
        </article>
      </span>
      <span v-else class="w-full pt-5 pb-7">
        <p class="font-medium">{{ translate('no experience', 'ucfirst') }}</p>
      </span>
    </Fieldset>
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";


const props = defineProps({
  experiences: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let isLoading = ref(false)
let listExperiences = ref([])


// ############ Criação de Métodos/Funções ############

const dateFormated = ((date) => {
  return date.slice(0,10);
})

onUpdated(() => { 
  isLoading.value = false
  if (props.experiences.length > 0){
    listExperiences.value = props.experiences
  }
})

onMounted(() => {
  isLoading.value = true
});
</script>